<div class="group-formers-content">
  @if (!this.loading) {
    <div class="title-wrapper">
      <div class="wrapper-text-h3">{{ settings?.name }}</div>
    </div>
    <div class="content-inputs">
      <div class="question-dragger-wrapper">
        <div class="dragger-description">
          I would like to form groups around people that meet the following criteria:
        </div>
        <div class="dragger-container" cdkDropListGroup>
          @for (rule of structuredRuleList; track rule.id; let ruleIdx = $index) {
            @if (ruleIdx > 0) {
              <div class="separator">Or</div>
            }

            <div class="rule-container">
              @if (rule.conditions.length > 0) {
                <div
                  cdkDropList
                  [id]="'cdk-drop-list-' + rule.id"
                  (cdkDropListDropped)="drop($event)"
                  cdkDropListOrientation="horizontal"
                  class="drag-container"
                >
                  @for (condition of rule.conditions; track condition; let containerIdx = $index) {
                    <group-former-option
                      [conditionIndex]="containerIdx"
                      [condition]="condition"
                      [questions]="roomBadgeQuestions"
                      [operators]="operators"
                      (transitionOperatorChange)="handleTransitionOperator($event, ruleIdx, containerIdx)"
                      (emitDeleteCondition)="handleDeleteCondition(ruleIdx, containerIdx)"
                    ></group-former-option>
                  }

                  <button
                    class="add-button"
                    (click)="addCondition(ruleIdx)"
                    [disabled]="checkMaxConditions()"
                    [matTooltip]="checkMaxConditions() ? 'Maximum number of group former rules has been reached.' : ''"
                  >
                    Add Condition
                  </button>
                </div>
              }
            </div>
            @if (rule.conditions.length <= 0) {
              <div>
                <button
                  class="add-button"
                  (click)="addCondition(ruleIdx)"
                  [disabled]="checkMaxConditions()"
                  [matTooltip]="checkMaxConditions() ? 'Maximum number of group former rules has been reached.' : ''"
                >
                  Add Condition
                </button>
              </div>
            }
          }

          <div class="add-rule-line">
            <button
              class="add-button"
              (click)="addRule()"
              [disabled]="checkMaxConditions()"
              [matTooltip]="checkMaxConditions() ? 'Maximum number of group former rules has been reached.' : ''"
            >
              Add Rule
            </button>
          </div>
        </div>
      </div>

      <div class="group-formers-slider-container">
        <div class="group-formers-text">How Many Group Formers Would You Like Per Group?</div>
        <div class="slider-wrapper">
          <div class="group-formers-counter">
            {{ groupFormerCountSelected }}
          </div>
          <div class="group-formers-slider">
            <mat-slider
              class="slider"
              aria-labelledby="group-formers-slider"
              [max]="maxGroupSize"
              [min]="1"
              [discrete]="true"
              #ngSlider
              ><input
                placeholder="slider"
                matSliderThumb
                [value]="groupFormerCountSelected"
                (change)="onGroupSizeChange({ source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value })"
                #ngSliderThumb="matSliderThumb"
              />
            </mat-slider>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-wrapper" [ngClass]="{ transparent: isFooterTransparent }">
      <button data-testid="primaryButton" class="primary-button" [disabled]="checkDisabledNext()" (click)="nextStep()">
        Continue
      </button>
    </div>
  } @else {
    <div class="flex justify-center w-full">
      <app-loading></app-loading>
    </div>
  }
</div>
